import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="w-full bg-primary-50 border-t border-primary-100 mt-16">
      <div className="mx-auto max-w-content px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-10 h-10 rounded-full bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-star-smile-line text-xl"></i>
              </span>
              <span className="font-heading text-lg font-semibold text-foreground-950">
                小泽玛利亚
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              专注小泽玛利亚个人资料、最新新闻与影视作品的粉丝资讯平台，为你第一时间带来她的动态。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-700 cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/works" className="text-sm text-foreground-600 hover:text-primary-700 cursor-pointer">
                  影视作品
                </Link>
              </li>
              <li>
                <Link to="/profile" className="text-sm text-foreground-600 hover:text-primary-700 cursor-pointer">
                  个人资料
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-700 cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">资讯分类</h4>
            <ul className="space-y-2.5">
              {categories.map((c) => (
                <li key={c.type}>
                  <Link
                    to={`/category/${c.type}`}
                    className="text-sm text-foreground-600 hover:text-primary-700 cursor-pointer"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">联系我们</h4>
            <ul className="space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-600"></i>
                contact@mariaozawa-fan.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-primary-600"></i>
                内容运营 · 线上平台
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <span className="w-9 h-9 rounded-full bg-background-50 border border-primary-200 text-primary-600 flex items-center justify-center cursor-pointer hover:bg-primary-100">
                <i className="ri-weibo-line"></i>
              </span>
              <span className="w-9 h-9 rounded-full bg-background-50 border border-primary-200 text-primary-600 flex items-center justify-center cursor-pointer hover:bg-primary-100">
                <i className="ri-instagram-line"></i>
              </span>
              <span className="w-9 h-9 rounded-full bg-background-50 border border-primary-200 text-primary-600 flex items-center justify-center cursor-pointer hover:bg-primary-100">
                <i className="ri-youtube-line"></i>
              </span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-100 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500 text-center sm:text-left">
            © {year} 小泽玛利亚明星资讯站 · 本站为粉丝向资讯平台，内容均为演示资料
          </p>
          <p className="text-xs text-foreground-500">
            本站内容仅供娱乐资讯展示使用
          </p>
        </div>
      </div>
    </footer>
  );
}